module.exports = __webpack_public_path__ + "static/media/paco-rabanne-lady-million-big.d56b4e20.png";